<template>
  <div id="statistics">
    <div>样本统计</div>
    <div class="chart">
      <div class="chart_inquireTime">
        <span style="margin-right: 10px">时间</span>
        <el-button @click="initTime(1)">今天</el-button>
        <el-button @click="initTime(3)">近三天</el-button>
        <el-button @click="initTime(7)">近七天</el-button>
        <el-button @click="initTime(30)">一个月</el-button>
        <el-button @click="initTime('all')">全部</el-button>
      </div>
      <div class="chart_inquireData">
        <span style="margin-right: 10px">日期</span>
        <el-date-picker
          value-format="yyyy/MM/dd HH:mm:ss"
          type="date"
          placeholder="选择日期"
          v-model="timeParams.beginTime"
        ></el-date-picker>
        <el-date-picker
          value-format="yyyy/MM/dd HH:mm:ss"
          type="date"
          placeholder="选择日期"
          v-model="timeParams.endTime"
        ></el-date-picker>
        <el-button @click="cx">查询</el-button>
      </div>
      <div class="Noechart" v-show="isShow == false">该时间下暂无数据</div>

      <div class="echart" ref="echart_div" v-show="isShow == true"></div>

      <sampleTable></sampleTable>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import sampleTable from "./sampleTable";
export default {
  components: {
    sampleTable,
  },
  data() {
    return {
      projectId: "", //项目id
      timeParams: {
        beginTime: "",
        endTime: "",
      },
      isShow: true,
    };
  },
  computed: {
    prCode() {
      return this.$store.state.pr_Code;
    },
  },
  watch: {
    prCode(newId, oldId) {
      if (newId) {
        this.projectId = newId;
        this.loadData();
      }
    },
  },
  mounted() {
    this.projectId = this.$store.state.pr_Code;
    this.loadData();
    this.initTime("all"); // 初始化时间
  },
  methods: {
    // 初始化时间
    initTime(value) {
      if (value == 1) {
        const endDate =
          this.getFormatDate(new Date()).substr(0, 11) + "23:59:59";
        const beginDate =
          this.getFormatDate(new Date()).substr(0, 11) + "00:00:00";
        this.timeParams = {
          beginTime: beginDate,
          endTime: endDate,
        };
      } else if (value == 3) {
        const endDate =
          this.getFormatDate(new Date()).substr(0, 11) + "23:59:59";
        const beginDate =
          this.getFormatDate(
            new Date(new Date() - 3600 * 1000 * 24 * 3)
          ).substr(0, 11) + "00:00:00";
        this.timeParams = {
          beginTime: beginDate,
          endTime: endDate,
        };
      } else if (value == 7) {
        const endDate =
          this.getFormatDate(new Date()).substr(0, 11) + "23:59:59";
        const beginDate =
          this.getFormatDate(
            new Date(new Date() - 3600 * 1000 * 24 * 7)
          ).substr(0, 11) + "00:00:00";
        this.timeParams = {
          beginTime: beginDate,
          endTime: endDate,
        };
      } else if (value == 30) {
        const endDate =
          this.getFormatDate(new Date()).substr(0, 11) + "23:59:59";
        const beginDate =
          this.getFormatDate(
            new Date(new Date() - 3600 * 1000 * 24 * 29)
          ).substr(0, 11) + "00:00:00";
        this.timeParams = {
          beginTime: beginDate,
          endTime: endDate,
        };
      } else if (value == "all") {
        const endDate = "";
        const beginDate = "";
        this.timeParams = {
          beginTime: beginDate,
          endTime: endDate,
        };
      }
      this.loadData();
    },
    // 获取当前时间
    getFormatDate(date) {
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentDate =
        date.getFullYear() +
        "-" +
        month +
        "-" +
        strDate +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds();
      return currentDate;
    },
    cx() {
      this.loadData();
    },
    loadData() {
      if (this.projectId == "") {
        return false;
      }
      let that = this;
      let params = {
        that: this,
        method: "POST",
        url: `${this.$config.service.querySampleStatisticsChart}`,
        data: {
          prCode: this.projectId,
          beginTime: this.timeParams.beginTime,
          endTime: this.timeParams.endTime,
        },
        cb(res) {
          if (res.result == "111111111111") {
            let xdataList = [];
            let sDataList = [];
            res.data.forEach((item) => {
              if (item.Ss_Id == 0) {
                item.Ss_Id_Name = "其他";
              }
              xdataList.push(item.Ss_Id_Name); //名
              sDataList.push(item.number); //值
            });
            if (xdataList.length != 0) {
              that.isShow = true;
            } else {
              that.isShow = false;
            }
            let getchart = echarts.init(that.$refs.echart_div);
            let option = {
              xAxis: {
                type: "category",
                data: xdataList,
              },
              color: ["#0080ff"],
              yAxis: {
                type: "value",
              },
              series: [
                {
                  data: sDataList,
                  type: "bar",
                  label: {
                    show: true,
                    position: "top",
                    fontSize: 22,
                  },
                },
              ],
            };
            getchart.clear();
            getchart.setOption(option);
            window.addEventListener("resize", () => {
              getchart.resize();
            });
          } else {
            that.$message.error(res.msg);
          }
        },
      };
      this.$util.request(params);
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
#statistics {
  width: 100%;
  height: 100%;
  margin-top: 60px;
  .chart {
    margin-top: 20px;
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    .chart_inquireTime {
      padding-left: 10px;
      padding-top: 5px;
    }
    .chart_inquireData {
      padding-left: 10px;
      padding-top: 5px;
    }
    .echart {
      height: 288px;
    }
    .Noechart {
      height: 288px;
      text-align: center;
      line-height: 288px;
    }
  }
}
</style>
